import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3 rounded-2xl border border-slate-200 p-3" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "text-xs font-semibold text-slate-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      checked: $props.modelValue,
      type: "checkbox",
      class: "h-5 w-5 rounded border-slate-300",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onChange && $setup.onChange(...args)))
    }, null, 40, _hoisted_2),
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString($props.label), 1)
      ])
    ])
  ]))
}